import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { PageHeader } from '../../components/PageHeader';

interface AccountSummary {
    id: number;
    name: string;
    balance: number;
    limit: number;
    available: number;
    companies: string[];
}

function formatBalance(balance: number): string {
    const abs = Math.abs(balance);
    const formatted = abs.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return balance < 0 ? `-$${formatted}` : `$${formatted}`;
}

export default function AccountReceivableList({ accounts }: { accounts: AccountSummary[] }) {
    return (
        <MainLayout>
            <Head>
                <title>Mis Cuentas Corrientes</title>
                <meta name="robots" content="noindex" />
            </Head>

            <div className="mx-auto max-w-6xl px-4 py-6">
                <PageHeader title="Mis Cuentas Corrientes" subtitle="Consultá el estado de tus cuentas corrientes." />

                <div className="mt-6 space-y-3">
                    {accounts.map((account) => (
                        <Link
                            key={account.id}
                            href={`/cuenta-corriente/${account.id}`}
                            className="flex items-center justify-between rounded-xl border border-gray-200 bg-white px-6 py-4 shadow-sm hover:bg-gray-50 transition-colors no-underline"
                        >
                            <div>
                                <div className="font-semibold text-gray-900">{account.name}</div>
                                {(account.companies?.length ?? 0) > 0 && (
                                    <div className="mt-0.5 text-xs text-gray-500">
                                        {account.companies.join(' · ')}
                                    </div>
                                )}
                            </div>
                            <div className="text-right">
                                <div className={`text-lg font-bold ${account.balance < 0 ? 'text-red-600' : 'text-green-600'}`}>
                                    {formatBalance(account.balance)}
                                </div>
                                <div className="text-xs text-gray-400">Saldo</div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </MainLayout>
    );
}
